import { Flex } from '@ui-library/misc';
import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import classes from '@components/sources/visualizer/mappingScreens/config/mappingConfig/mapping-commons.module.scss';
import DropDownMenu from './dropDownMenu';
import { HeaderWrapper, SearchInput } from './style';
import { useMappingState } from '../tableMappingProvider';
import ReloadColumns from '../../reloadColumns';

const TableHeader: React.FC = () => {
  const {
    selectedColumns,
    tableData,
    setSelectedRow,
    setRenamedRows,
    setSearchKeyword,
    viewOnly,
    refreshColumns,
    sourceConfig,
    role,
    updateSchemaErrors,
  } = useMappingState();
  const totalRows = Object.keys(tableData || {}).length;
  const totalselectedColumns = selectedColumns.length;
  const menu = [
    {
      label: 'Select all columns',
      onClick: () => setSelectedRow(Object.keys(tableData || {})),
    },
    {
      label: 'Deselect all columns',
      onClick: () => setSelectedRow([]),
    },
    {
      label: 'Reset table to original',
      style: { color: 'red' },
      onClick: () => setRenamedRows(null),
    },
  ];

  return (
    <HeaderWrapper alignItems="center" className="table-header_container">
      <SearchInput
        onChange={(e) => setSearchKeyword(e.target.value)}
        size="large"
        placeholder="Search columns"
        prefix={<SearchOutlined />}
      />
      <span className={classes.table_header_reload_columns}>
        <ReloadColumns
          sourceConfig={sourceConfig}
          role={role}
          refreshColumns={refreshColumns}
          hide={viewOnly}
          updateSchemaErrors={updateSchemaErrors}
        />
      </span>
      <Flex alignItems="center" style={{ marginLeft: 'auto', color: '#6C757D' }}>
        <div style={{ marginRight: 12 }}>
          {totalselectedColumns}/{totalRows} selected
        </div>
        {!viewOnly ? <DropDownMenu placeholder="More" items={menu} /> : null}
      </Flex>
    </HeaderWrapper>
  );
};

export default TableHeader;
